export interface TopicItem {
  id: number;
  tag: string;
  title: string;
  summary: string;
  views: string;
  replies: string;
  heat: string;
  image: string;
  featured?: boolean;
}

export interface BoardItem {
  id: number;
  name: string;
  desc: string;
  members: string;
  posts: string;
  icon: string;
  accent: string;
}

export interface DiscussionItem {
  id: number;
  author: string;
  title: string;
  preview: string;
  time: string;
  replies: string;
  avatar: string;
}

export interface EntranceItem {
  id: number;
  label: string;
  address: string;
  status: string;
  online: string;
}

export interface FaqItem {
  id: number;
  q: string;
  a: string;
}

export const topicItems: TopicItem[] = [
  {
    id: 1,
    tag: "今日热瓜",
    title: "年末颁奖礼名场面大赏：红毯造型谁最出圈？",
    summary:
      "昨晚红毯环节承包了一整晚的高能输出，造型师连夜上热搜。我们盘点了被网友反复回看的几个名场面，来看看大家的审美有没有达成共识。",
    views: "128.6万",
    replies: "4821",
    heat: "98",
    featured: true,
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20red%20carpet%20awards%20ceremony%20with%20warm%20spotlight%20glow%20and%20elegant%20dramatic%20lighting%2C%20glamorous%20night%20event%20atmosphere%2C%20film%20photography%20style%2C%20soft%20bokeh%20background%2C%20high%20detail%2C%20harmonious%20composition&width=1200&height=760&seq=topic-featured-01&orientation=landscape",
  },
  {
    id: 2,
    tag: "综艺切片",
    title: "这期真人秀的胜负欲也太真实了",
    summary:
      "节目组这个游戏设置看得人血压升高，嘉宾反应全程高能。",
    views: "76.3万",
    replies: "2304",
    heat: "87",
    image:
      "https://readdy.ai/api/search-image?query=vibrant%20reality%20tv%20game%20show%20studio%20with%20bright%20colorful%20set%20and%20cameras%2C%20playful%20competitive%20energy%2C%20editorial%20television%20photography%2C%20warm%20fill%20lighting%2C%20clean%20composition&width=800&height=520&seq=topic-card-02&orientation=landscape",
  },
  {
    id: 3,
    tag: "网剧观察",
    title: "反转不断，这部短剧凭什么刷屏",
    summary:
      "从立项到播出仅三个月，节奏快到停不下来，编剧有多敢写？",
    views: "54.8万",
    replies: "1996",
    heat: "79",
    image:
      "https://readdy.ai/api/search-image?query=moody%20drama%20series%20filming%20scene%20with%20cinematic%20contrast%20lighting%20and%20film%20set%20equipment%2C%20dark%20edgy%20television%20production%20atmosphere%2C%20editorial%20behind%20the%20scenes%2C%20high%20detail&width=800&height=520&seq=topic-card-03&orientation=landscape",
  },
  {
    id: 4,
    tag: "主播热闻",
    title: "开箱现场意外翻车，评论区笑疯了",
    summary:
      "一段十秒的直播失误，被网友做成了一套表情包，当事人已回应。",
    views: "42.1万",
    replies: "1752",
    heat: "72",
    image:
      "https://readdy.ai/api/search-image?query=live%20streaming%20studio%20desk%20with%20boxes%20and%20ring%20light%20setup%2C%20casual%20fun%20vibe%2C%20editorial%20photography%2C%20warm%20natural%20tone%2C%20clean%20composition&width=800&height=520&seq=topic-card-04&orientation=landscape",
  },
  {
    id: 5,
    tag: "赛场热议",
    title: "加时绝杀之夜，观众席名场面",
    summary:
      "最后三十秒三度反转，现场和解说都坐不住了，一起来复盘。",
    views: "60.9万",
    replies: "2108",
    heat: "83",
    image:
      "https://readdy.ai/api/search-image?query=intense%20sports%20arena%20finish%20line%20with%20crowd%20cheering%20under%20bright%20stadium%20lights%2C%20dramatic%20final%20moment%2C%20editorial%20sports%20photography%2C%20warm%20highlight%20tones%2C%20high%20energy&width=800&height=520&seq=topic-card-05&orientation=landscape",
  },
];

export const boardItems: BoardItem[] = [
  {
    id: 1,
    name: "吃瓜闲谈",
    desc: "没有热搜的时候，大家的瓜都在这里翻出来聊。",
    members: "32.4万",
    posts: "15.8万",
    icon: "ri-chat-smile-3-line",
    accent: "primary",
  },
  {
    id: 2,
    name: "影视剧综",
    desc: "追剧追综心得、安利与吐槽，今天也在为剧情上头。",
    members: "28.1万",
    posts: "11.2万",
    icon: "ri-movie-2-line",
    accent: "secondary",
  },
  {
    id: 3,
    name: "圈内八卦",
    desc: "理性吃瓜区，聊聊幕后那些事儿，发言请友好。",
    members: "19.6万",
    posts: "7.9万",
    icon: "ri-magic-line",
    accent: "accent",
  },
  {
    id: 4,
    name: "主播前线",
    desc: "直播高光与名场面汇总，弹幕梗这里最全。",
    members: "15.3万",
    posts: "5.6万",
    icon: "ri-radio-2-line",
    accent: "secondary",
  },
  {
    id: 5,
    name: "赛场夜话",
    desc: "体育竞技与观赛日常，理性讨论比分与表现。",
    members: "11.8万",
    posts: "3.4万",
    icon: "ri-emotion-happy-line",
    accent: "primary",
  },
];

export const discussionItems: DiscussionItem[] = [
  {
    id: 1,
    author: "爱熬夜的瓜农",
    title: "红毯这套造型你们打几分？我觉得被低估了",
    preview:
      "仔细看了好几遍生图，配色和剪裁其实都很在线，只是镜头太吃光显得平平……",
    time: "12分钟前",
    replies: "316",
    avatar: "瓜",
  },
  {
    id: 2,
    author: "前排吃瓜王",
    title: "这期游戏规则我看了三遍才懂，节目组是懂反转的",
    preview:
      "原本以为稳赢的那组，最后被规则绕进去了，弹幕已经笑成一片。",
    time: "35分钟前",
    replies: "204",
    avatar: "王",
  },
  {
    id: 3,
    author: "剧荒自救指南",
    title: "被安利去看了这部短剧，前两集就停不下来了",
    preview:
      "节奏是真快，没有一句废话，唯一缺点是更新太慢，等得好苦。",
    time: "1小时前",
    replies: "158",
    avatar: "剧",
  },
  {
    id: 4,
    author: "凌晨四点睡不着",
    title: "直播那段失误重看了五遍，太真实了哈哈",
    preview:
      "主播自己也绷不住了，这个素材够网友玩一年的，表情包已存。",
    time: "2小时前",
    replies: "96",
    avatar: "四",
  },
  {
    id: 5,
    author: "理性看球选手",
    title: "最后一球到底算不算绝杀，欢迎理性讨论",
    preview:
      "角度、踩线、时间戳我都放上来了，大家帮忙看看判罚有没有问题。",
    time: "3小时前",
    replies: "412",
    avatar: "球",
  },
];

export const entranceItems: EntranceItem[] = [
  {
    id: 1,
    label: "当前正式入口",
    address: "www.chigua.example",
    status: "可正常访问",
    online: "在线",
  },
  {
    id: 2,
    label: "备用入口 · 一号",
    address: "app.chigua.example",
    status: "可正常访问",
    online: "在线",
  },
  {
    id: 3,
    label: "备用入口 · 二号",
    address: "new.chigua.example",
    status: "随时启用",
    online: "待命",
  },
];

export const faqItems: FaqItem[] = [
  {
    id: 1,
    q: "为什么需要备用入口？",
    a: "网络环境偶尔会不稳定，主入口可能出现短时波动。为保证大家随时能进，我们常年维护了多条独立通道，一条失效会自动切换到其余入口，不影响正常使用。",
  },
  {
    id: 2,
    q: "换址信息在哪里第一时间更新？",
    a: "请优先收藏本站，并在评论区或导航栏关注我们。每次入口调整都会在首页顶部发布醒目公告，并同步在讨论区置顶更新，老用户据此即可第一时间获取最新地址。",
  },
  {
    id: 3,
    q: "收藏本站能一直有效吗？",
    a: "收藏的是本站页面而非临时链接，只要您保存的入口仍在维护，收藏便持续有效。即便发生换址，页面上也会自动呈现最新可用入口，真正做到吃瓜不迷路。",
  },
  {
    id: 4,
    q: "访问时需要登录或付费吗？",
    a: "不需要。本站所有讨论内容均可直接浏览，入口指引与公告也是免费公开的，不会以任何形式向访问者收取费用。",
  },
];